import {obvioUrl} from 'lib/url'
import {Widget} from 'Event/Widget/template'
import {uuid} from 'lib/uuid'
import {useCallback, useEffect, useState} from 'react'

export type WidgetType = 'redirect' | 'button' | 'calendar'

export interface WidgetCodeType {
  widgetCode: string
  regenerate: () => void
}

export function useWidgetCode(
  type: WidgetType,
  widget: Widget,
): WidgetCodeType {
  const [widgetCode, setWidgetCode] = useState<string>('')

  const regenerate = useCallback(() => {
    const containerId = `obvio-widget-${uuid()}-${type}`

    const url = `${obvioUrl(
      '/widget/obvio_widget.js',
    )}?c=${containerId}&t=${type}&at=${widget.token}`

    const generatedCode = `<!-- Obv.io Widget Code -->
      <div id="${containerId}"></div>
      <script
      src="${url}"
      async>
      </script>
<!-- Obv.io Widget Code End -->`

    setWidgetCode(generatedCode)
  }, [type, widget.token])

  useEffect(() => {
    regenerate()
  }, [type, widget, regenerate])

  return {
    widgetCode,
    regenerate,
  }
}
